import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", { d: "M12 11.11c-1.52 0-2.75-1.23-2.75-2.75S10.48 5.61 12 5.61s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75Zm0-4a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z" }, null, -1), l = /* @__PURE__ */ t("path", { d: "M12 23.039c-.563 0-1.08-.282-1.39-.761l-5.327-8.277c-1.729-2.48-1.992-5.609-.695-8.37 1.25-2.678 3.739-4.407 6.651-4.642a10.288 10.288 0 0 1 1.522 0c2.913.235 5.402 1.964 6.652 4.641 1.296 2.762 1.033 5.9-.705 8.38l-5.317 8.268c-.3.47-.818.761-1.39.761ZM12 2.37c-.216 0-.432 0-.648.028-2.396.188-4.453 1.626-5.487 3.833-1.08 2.302-.864 4.905.583 6.972 0 0 .01.018.019.018l5.336 8.296c.122.197.282.188.395 0l5.336-8.296c1.466-2.085 1.682-4.697.601-6.999-1.033-2.208-3.09-3.645-5.486-3.833A7.48 7.48 0 0 0 12 2.361v.01Z" }, null, -1), s = [
  n,
  l
];
function r(a, d) {
  return e(), c("svg", o, [...s]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
